// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"3c358074","592":"1718a864"}[chunkId] + ".js";
};